export class CostReviewSummary {
  projectName!: string;
  customerName!: string;
  siteLocation!: string;
  isUserProjectCategory!: boolean;
  projectCategoryVerification!: number;
  consultingEngineer!: string;
  architectureFirm!: string;
  constructionManager!: string;
  jobsiteRtMileage!: number;
  projectStartDate!: Date;
  projectEndDate!: Date;
  projectDuration!: number;
  estimateDepth!: number;
  alternatesIncluded!: number;
  opportunityLinked!: string;
  construction!: number;
  sufficientSpace!: number;
  isGraphicsStandardVerifiedWithGISVisible!: boolean;
  graphicsStandardVerifiedWithGIS!: number;
  projectScope!: number;
  clarityOfScope!: number;
  commissioningRequirements!: number;
  mvReporting!: number;
  resourceRequirements!: number;
  thirdPartyResources!: number;
  siteAccess!: number;
  highWorkArea!: number;
  isCDP!: string;
  projectScopeDescription!: string;
  thirdPartyResourceRequiredDescription!: string;
  projectScopeSelection!: boolean;
  thirdPartyResourceRequiredSelection!: boolean;
  authorityHavingJurisdiction!: string;
  nationalOrEnterpriseAccount!: number;
  shipToLocation!: string;
  proposalLinked!: string;
  contigencyIncluded!: number;
  siemensPrimeBidder!: number;
  zteApprovalReceived!: number;
  smApprovalRecieved!: number | null;
  fireTaskBasedEstimating!: string;
  isTBESMApprovalVisible!: boolean;
  isTBEApprovalTaken!: boolean;
  isFireTBEVisibility!: boolean;
  isPriceRecommenderUsed!: string;
  verticalMarket!: string;
  laborEfficiency!: string;
  isEnergyOMReviewRequired!: string;
  isEnergyOMReviewRequiredVisible!: boolean;
  isCollaborative!: string;
  hasJobDetailsValidationError!: boolean;
  jobDetailsSelectedProductType!: string;
  jobDetailsInstallationType!: string;
  jobDetailsSiteSize!: number;
  jobDetailsAntennaQty!: number;
  jobDetailsAgentWeight!: number;
  jobDetailsCleanAgentVolSpace!: number;
}
